<div *ngIf="initializing">
    <lsq-circle-loader></lsq-circle-loader>
</div>
<div *ngIf="!initializing">
    <lsq-banner [titleText]="i18n.BannerHeader" [subTitle]="lastUpdatedDate | lastUpdatedDate">
    </lsq-banner>
    <div class="invoice-details page-container container-fluid">
        <div class="row">
            <div class="col-md-6">
                <div class="invoice-header">
                    <a
                        class="font-weight-bold debtor-name"
                        [routerLink]="getOverviewLink(invoice.debtorKey)"
                    >
                        {{ invoice.debtorName }}
                    </a>
                    <h2 class="invoice-number">
                        {{ i18n.InvoiceNumber }} {{ invoice.invoiceNumber }}
                        <a
                            *ngIf="isInvoiceImageViewable"
                            class="invoice-image-preview-btn"
                            href="javascript:void(0)"
                            (click)="showInvoicePreviewModal()"
                        >
                            <lsq-icon [type]="icons.ImageFile" [width]="14" [height]="18">
                            </lsq-icon>
                        </a>
                    </h2>
                    <h3 class="invoice-amount">
                        {{ invoice.invoiceAmount | currency }}
                    </h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="invoice-data-row row">
                    <div class="col-4">
                        <label for="invoiceDate">{{ i18n.InvoiceDate }}</label>
                        <h3 id="invoiceDate">
                            {{
                                invoice.invoiceDate
                                    ? (invoice.invoiceDate | date: shortDateFormat)
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                    <div class="col-4">
                        <label for="dueDate">{{ i18n.DueDate }}</label>
                        <h3 id="dueDate">
                            {{
                                invoice.dueDate
                                    ? (invoice.dueDate | date: shortDateFormat)
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                    <div class="col-4">
                        <label for="purchaseDate">{{ i18n.PurchaseDate }}</label>
                        <h3 id="purchaseDate">
                            {{
                                invoice.purchaseDate
                                    ? (invoice.purchaseDate | date: shortDateFormat)
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                </div>
                <div class="invoice-data-row row">
                    <div class="col-4">
                        <label for="terms">{{ i18n.Terms }}</label>
                        <h3 id="terms">
                            {{ invoice.terms ? invoice.terms + i18n.Days : i18n.NullValue }}
                        </h3>
                    </div>
                    <div class="col-4">
                        <label for="daysPastDue" [popover]="i18n.DaysPastDueToolTip">
                            {{ i18n.DaysPastDue }}
                        </label>
                        <h3 id="daysPastDue">
                            {{
                                invoice.daysPastDue && invoice.daysPastDue > 0
                                    ? invoice.daysPastDue + i18n.Days
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                    <div class="col-4">
                        <label for="age" [popover]="i18n.AgeToolTip">
                            {{ i18n.Age }}
                        </label>
                        <h3 id="age">
                            {{ invoice.age ? invoice.age + i18n.Days : i18n.NullValue }}
                        </h3>
                    </div>
                </div>
                <div class="invoice-data-row row">
                    <div class="col-4">
                        <label
                            for="balanceDue"
                            [popover]="i18n.BalanceDueToolTip"
                            [popoverPlacement]="placement.TopRight"
                        >
                            {{ i18n.BalanceDue }}
                        </label>
                        <h3 id="balanceDue">
                            {{
                                invoice.balanceDue
                                    ? (invoice.balanceDue | currency)
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                    <div class="col-4">
                        <label for="partialPayment" [popover]="i18n.PartialPaymentToolTip">
                            {{ i18n.PartialPayment }}
                        </label>
                        <h3 id="partialPayment">
                            {{
                                invoice.partialPayment
                                    ? (invoice.partialPayment | currency)
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                    <div class="col-4">
                        <label for="lastPaymentDate">{{ i18n.LastPaymentDate }}</label>
                        <h3 id="lastPaymentDate">
                            {{
                                invoice.lastPaymentDate
                                    ? (invoice.lastPaymentDate | date: shortDateFormat)
                                    : i18n.NullValue
                            }}
                        </h3>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mt-5">
                <card headerTitle="Invoice History">
                    <div card-body>
                        <lsq-data-table [dataSource]="tableDataSource" [layoutFixed]="true">
                            <lsq-column
                                [column]="{
                                    header: 'Date',
                                    key: 'date',
                                    sortable: false,
                                    width: '45%'
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <a
                                        class="truncated-text"
                                        [popover]="row.date"
                                        [href]="
                                            row.activity === 'Purchase'
                                                ? getPurchaseURL(row.date)
                                                : getCollectionURL(row.date)
                                        "
                                    >
                                        {{ this._getDateFormat(row.date) }}
                                    </a>
                                </ng-template>
                            </lsq-column>
                            <lsq-column
                                [column]="{
                                    header: 'Activity',
                                    key: 'activity',
                                    sortable: false,
                                    width: '35%'
                                }"
                            >
                            </lsq-column>

                            <lsq-currency-column
                                [column]="{
                                    header: 'Amount',
                                    key: 'amount',
                                    sortable: false,
                                    width: '20%'
                                }"
                            >
                            </lsq-currency-column>
                        </lsq-data-table>
                    </div>
                </card>
            </div>
        </div>
    </div>
</div>
